import type { ReactNode } from "react";
import { cn } from "~/shared/lib/utils";
import { SidebarTrigger } from "~/shared/ui/sidebar";
import { SECTION_V5 } from "./design-tokens";

export interface SotaPageHeaderProps {
    title: ReactNode;
    actions?: ReactNode;
    className?: string;
}

export function SotaPageHeader({ title, actions, className }: SotaPageHeaderProps) {
    return (
        <div className={cn("flex w-full items-center gap-2", className)}>
            {/* Mobile-only menu trigger opens the sidebar drawer (the desktop sidebar is
                always visible from lg up). Unified pattern across all section/page headers. */}
            <SidebarTrigger className="-ml-1 shrink-0 lg:hidden" />
            <h1 className={SECTION_V5.pageHeaderTitle}>{title}</h1>
            {actions ? <div className="ml-auto flex items-center gap-2">{actions}</div> : null}
        </div>
    );
}
